export const removeLeading = (char, string) =>
  string.charAt(0) === char ? string.slice(1) : string;
export default removeLeading;
